export const helpSections = [
  {
    id: "quickstart",
    title: "Pika-aloitus",
    tags: ["aloitus", "eka kerta", "käyttöönotto", "verkkosivu", "paketti"],
    pages: ["admin", "settings", "songs", "requests"],
    summary:
      "Näin saat oman Paranoidi-verkkosivun käyttöön. Näkyvät ominaisuudet riippuvat tilausmuodostasi.",
    steps: [
      "Lisää Asetuksissa esiintyjän julkisen sivun otsikko ja esittely.",
      "Paketistasi riippuen voit lisätä sivulle myös hero-kuvan, some-linkkejä, nettisivun, WhatsApp-linkin ja muita yhteystietoja.",
      "Lisää biisit Biisikirjastoon. Kokeilussa ja Basicissa voit lisätä biisejä käsin; Plus-paketissa käytössä ovat myös laajemmat tuonnit.",
      "Avaa biisitoiveet yleisölle, kun haluat ottaa toiveita vastaan.",
      "Jaa yleisölle oma Paranoidi-linkki tai QR-koodi. Asetuksista voit myös tulostaa QR-koodista A4-julisteen tai ladata sen PNG- tai SVG-tiedostona.",
      "Seuraa toiveita Toivehallinnassa ja merkitse niitä nähdyksi tai soitetuksi.",
      "Plus-käyttäjänä voit lisäksi lisätä tapahtumia, kohdistaa biisitoiveita tiettyyn tapahtumaan, tehdä settilistoja, käyttää lukutilaa, prompteria, keikkamuistia ja tallentaa keikkaraportteja.",
    ],
  },
  {
    id: "public-channel",
    title: "Julkinen Paranoidi-sivu",
    tags: ["verkkosivu", "julkinen sivu", "biisitoiveet", "qr", "linkki"],
    pages: ["settings", "admin"],
    summary:
      "Paranoidi on esiintyjän oma verkkosivu, jonka yleisö avaa QR-koodilla tai linkillä.",
    steps: [
      "Asetuksissa voit muokata julkisen sivun otsikkoa ja esittelytekstiä.",
      "Kokeilussa saat käyttöön oman julkisen Paranoidi-sivun, QR-koodin, jaettavan linkin ja perustoiminnot biisitoiveille.",
      "Basic- ja Plus-paketeissa voit viimeistellä sivua laajemmin esimerkiksi kuvalla, some-linkeillä, nettisivulla ja WhatsApp-yhteydellä.",
      "Kun biisitoiveet ovat auki, yleisö voi hakea biisejä ja lähettää toiveita suoraan sivulta.",
      "Plus-paketissa voit lisätä hallinnasta tapahtumia. Jos tapahtuma on aktiivinen ja biisitoiveet ovat avoinna, yleisö voi kohdistaa biisitoiveen tiettyyn tapahtumaan.",
       "Jos käytät biisitoiveiden yhteydessä mahdollista arvontaa, ota arvonta käyttöön Asetuksista. Silloin yleisö voi halutessaan valita osallistuvansa arvontaan biisitoiveen lähetyksen yhteydessä.",
      "Kun biisitoiveet ovat kiinni, sivu toimii edelleen esiintyjän julkisena promosivuna. Yleisö voi nähdä esittelyn, ohjelmiston ja paketista riippuen myös kuvan, linkit ja yhteydenottotavat.",
      "Biisitoiveita ei tarvitse pitää aina auki. Voit käyttää Paranoidi-sivua myös keikkojen välillä esiintyjän esittelysivuna.",
      "Esiintyjä päättää itse, mitä sivulla näytetään ja milloin biisitoiveet ovat käytössä.",
    ],
  },
  {
    id: "public-search",
    title: "Biisihaku ja Satunnainen kappale",
    tags: [
      "biisihaku",
      "haku",
      "ohjelmisto",
      "satunnainen kappale",
      "kieli",
      "kielisuodatus",
      "toivo tätä biisiä",
    ],
    pages: ["admin", "songs", "requests"],
    summary:
      "Julkisella Paranoidi-sivulla yleisö voi selata esiintyjän ohjelmistoa, hakea kappaleita ja löytää Satunnaisen kappaleen.",
    steps: [
      "Yleisö voi hakea esiintyjän ohjelmistosta esimerkiksi kappaleen tai artistin nimellä sekä ohjelmistoon tallennetuilla tiedoilla.",
      "Piilota toiveista -tilassa olevat biisit eivät näy yleisön tavallisessa biisitoivehaussa.",
      "Basic- ja Plus-paketeissa julkisen ohjelmiston kielisuodatusta voidaan rajata valitun kielen mukaan. Kokeilussa ohjelmisto näytetään Kaikki kielet -tilassa.",
      "Satunnainen kappale valitsee kappaleen esiintyjän yleisölle toivottavissa olevasta ohjelmistosta.",
      "Samassa selaimessa Satunnainen kappale -toimintoa voi käyttää enintään 10 kertaa päivässä.",
      "Jos biisitoivekanava on avoinna, löydetyn kappaleen voi avata suoraan biisitoiveeksi.",
      "Satunnainen kappale ei ole palkintoarvonta. Palkintoarvonta on erillinen toiminto, johon yleisö osallistuu erillisellä valinnalla biisitoiveen yhteydessä.",
    ],
  },
    {
    id: "settings",
    title: "Asetukset",
    tags: [
      "asetukset",
      "yleisösivu",
      "maksut",
      "stripe",
      "qr",
      "qr-koodi",
      "google",
      "linkit",
      "ulkoasu",
      "teema",
      "tallennus",
    ],
    pages: ["settings"],
    summary:
      "Asetuksissa hallitset julkista Paranoidi-sivuasi, maksuja, QR-koodia, Google-tietoja, linkkejä ja Paranoidin hallinnan ulkoasua.",
    steps: [
      "Asetukset on jaettu kuuteen osioon: Yleisösivu, Maksut, QR-koodi, Google, Linkit ja Ulkoasu.",
      "Sivun yläosan pikanavigaatiolla voit siirtyä suoraan haluamaasi asetusten osioon.",
      "Yleisösivu-kohdassa hallitset julkisen Paranoidi-sivun perustietoja, biisitoivekanavaa ja muita yleisölle näkyviä asetuksia.",
      "Maksut-kohdassa hallitaan Stripe-yhteyttä ja maksullisia biisitoiveiden näkyvyysnostoja silloin, kun ominaisuus on käytettävissä.",
      "QR-koodi-kohdassa näet oman julkisen Paranoidi-sivusi QR-koodin. Voit tulostaa siitä A4-julisteen tai ladata QR-koodin PNG- tai SVG-tiedostona.",
      "QR-koodi johtaa aina esiintyjän omalle julkiselle Paranoidi-sivulle.",
      "Google-kohdassa voit paketistasi riippuen muokata Google-otsikkoa, Google-kuvausta ja usein kysyttyjä kysymyksiä.",
      "Linkit-kohdassa hallitset julkisella sivulla näkyviä yhteystietoja ja linkkejä.",
      "Ulkoasu-kohdassa hallitset Paranoidin hallinnan ulkoasua. Hallinnan vaalea tai tumma teema ei vaihda julkisen Paranoidi-sivun yleisöulkoasua.",
      "Tallenna muutokset sivun mukana kulkevalla Tallenna asetukset -painikkeella. Tallennuspalkki pysyy näkyvissä myös silloin, kun selaat pitkää Asetukset-sivua.",
    ],
  },
  {
    id: "seo-faq",
    title: "Google-näkyvyys ja usein kysytyt kysymykset",
    tags: [
      "seo",
      "hakukoneoptimointi",
      "google",
      "ukk",
      "faq",
      "usein kysytyt",
      "promosivu",
    ],
    pages: ["settings", "admin"],
    summary:
      "Basic- ja Plus-paketeissa voit lisätä julkiselle Paranoidi-sivulle Google-otsikon, Google-kuvauksen ja usein kysytyt kysymykset.",
    steps: [
      "Google-otsikko ja Google-kuvaus auttavat kertomaan hakutuloksissa ja linkin jaossa, kenelle sivu kuuluu ja mihin esiintyjä sopii.",
      "Usein kysytyt kysymykset näkyvät julkisella Paranoidi-sivulla esiintyjän esittelyn ja biisitoiveiden tukena.",
      "UKK-kysymyksillä voi vastata esimerkiksi siihen, mihin tilaisuuksiin esiintyjä sopii, voiko biisejä toivoa ja miten yhteydenotto onnistuu.",
      "Kun biisitoiveet ovat kiinni, Paranoidi-sivu toimii edelleen esiintyjän promosivuna. UKK auttaa yleisöä ja tilaajia ymmärtämään nopeasti, mitä esiintyjä tarjoaa.",
      "Kokeilussa Paranoidi käyttää julkisen sivun perustietoja. Google-näkyvyyden ja UKK:n muokkaus kuuluu Basic- ja Plus-paketteihin.",
    ],
    },
    {
    id: "song-library",
    title: "Biisikirjasto",
    tags: [
      "biisit",
      "kirjasto",
      "ohjelmisto",
      "genre",
      "kieli",
      "vuosikymmen",
      "tempo",
      "rauhallinen",
      "keskitempo",
      "menevä",
      "toivottavissa",
      "piilotus",
      "massatoiminto",
      "massamuokkaus",
      "valitse koko kirjasto",
      "valitse hakutulokset",
      "näkyvyys",
      "suodatus",
    ],
    pages: ["songs", "admin"],
    summary:
      "Biisikirjasto on esiintyjän ohjelmisto. Siellä hallitset biisien tietoja, tempoa ja sitä, mitkä kappaleet näkyvät yleisölle biisitoiveissa.",
    steps: [
      "Lisää biisit muodossa: Biisin nimi - Esittäjä.",
      "Kokeilussa voit lisätä enintään 20 biisiä.",
      "Basic-paketissa voit lisätä enintään 100 biisiä.",
      "Plus-paketissa voit lisätä enintään 500 biisiä ja käyttää laajempia tuontiominaisuuksia.",

      "Biiseille voidaan tallentaa esimerkiksi kieli, genre, vuosikymmen, tempo ja tilaisuustägejä. Näitä tietoja voidaan käyttää Biisikirjaston suodatuksessa ja muissa Paranoidin työkaluissa.",

      "Tempo voidaan merkitä arvoilla Rauhallinen, Keskitempo tai Menevä. Jos tempoa ei ole vielä määritelty, biisi löytyy Tempo puuttuu -suodattimella.",

      "Yläosan hakukenttä sekä artisti-, genre-, vuosikymmen-, tempo-, kieli- ja näkyvyyssuodattimet rajaavat listaa. Pelkkä suodattaminen ei muuta biisien tietoja.",

      "Voit yhdistää useita suodattimia. Voit esimerkiksi näyttää vain tietyn artistin menevät biisit tai tietyn genren rauhalliset kappaleet.",

      "Valitse koko kirjasto valitsee kaikki Biisikirjaston biisit massamuokkausta varten riippumatta aktiivisista rajauksista. Valitse hakutulokset valitsee puolestaan vain nykyiseen hakuun ja suodattimiin kuuluvat biisit.",

      "Massamuokkauksella voit muuttaa valittujen biisien kieltä, genreä, vuosikymmentä, tempoa, tilaisuustägejä ja näkyvyyttä biisitoiveissa.",

      "Jos esimerkiksi haluat yleisön voivan toivoa vain meneviä biisejä, valitse ensin Valitse koko kirjasto → Piilota toiveista ja tallenna. Rajaa sen jälkeen Tempo → Menevä, paina Valitse hakutulokset → Näytä toiveissa ja tallenna. Näin vain meneviksi merkityt biisit jäävät yleisölle toivottaviksi.",

      "Piilota toiveista poistaa biisin yleisön biisitoivehausta. Biisi säilyy silti omassa Biisikirjastossa ja muissa esiintyjän työkaluissa.",

      "Palauta tai Näytä toiveissa palauttaa biisin yleisön biisitoivehakuun.",

      "Yksittäistä biisiä voi muokata Muokkaa-painikkeella. Siellä voit vaihtaa myös biisin tempon.",

      "Biisikortissa määritelty tempo näkyy omana tunnisteena, esimerkiksi Rauhallinen, Keskitempo tai Menevä.",

      "Voit poistaa useita biisejä kerralla valitsemalla biisit ja käyttämällä massapoistoa. Poisto pitää vahvistaa erikseen.",

      "Biisien näkyvyyden hallinta kuuluu Basic- ja Plus-paketteihin.",

      "Sanat ja soinnut sekä niiden keikkakäyttö lukutilassa ja prompterissa kuuluvat Plus-pakettiin. Sisältö voidaan tuoda SongBook/ChordPro-tiedostosta tai tallentaa biisin tietoihin käytettävissä olevilla Plus-työkaluilla.",
    ],
  },
  {
    id: "imports",
    title: "Tiedostotuonti ja ChordPro",
    tags: ["tuonti", "pdf", "docx", "songbook", "chordpro", "sanat", "soinnut"],
    pages: ["songs"],
    summary:
      "Tuonti nopeuttaa ohjelmiston rakentamista. Laajemmat tuonnit kuuluvat Plus-pakettiin.",
    steps: [
      "Kokeilussa ja Basicissa biisejä voi lisätä käsin muodossa: Biisin nimi - Esittäjä.",
      "Plus-paketissa käytössä ovat biisien massatuonti, PDF/DOCX-tuonti, SongBook/ChordPro-tuonti sekä tuonti Google Drive -jakolinkistä.",
      "PDF- ja DOCX-tuonti yrittää tunnistaa tiedostosta biisin nimen, artistin ja sävellajin silloin, kun tiedot voidaan päätellä luotettavasti.",
      "Tarkista aina tuonnin esikatselu ennen tallennusta. Jos jotakin tietoa ei tunnisteta tai se on väärin, korjaa tieto ennen kuin tallennat biisin kirjastoon.",
      "Google Drive -tuonnissa tiedosto pitää jakaa niin, että linkin saanut voi avata sen: Google Drive → Jaa → Yleinen käyttöoikeus → Kaikki linkin saaneet → Katsoja.",
      "Jos Google Drive -linkistä tuonti ei onnistu, saman tiedoston voi tuoda suoraan laitteelta.",
      "SongBook/ChordPro-tuonnissa voit valita myös useita PRO-tiedostoja kerralla. Tuonnissa voidaan säilyttää biisin nimi, artisti, sävellaji, sanat ja soinnut.",
      "Hae tiedot verkosta -toiminnolla voit etsiä tuodulle kappaleelle lisätietoja. Tarkista ehdotukset ja valitse oikea kappale ennen tietojen käyttämistä.",
      "Jos verkkohaku ei löydä luotettavaa osumaa, Paranoidi ei keksi puuttuvia kappaletietoja. Tiedot voi silloin täydentää käsin.",
      "Sanat ja soinnut eivät synny automaattisesti biisilistasta, PDF:stä tai DOCX:stä. Ne näkyvät vain, jos ne tulevat SongBook/ChordPro-tiedostosta tai ne lisätään käsin biisin Muokkaa-toiminnolla.",
      "Lukutila ja prompteri hyödyntävät biisikohtaisia sanoja, sointuja ja muistiinpanoja. Lukutila ja prompteri kuuluvat Plus-pakettiin.",
    ],
  },
  {
    id: "events",
    title: "Tapahtumat",
    tags: [
      "tapahtumat",
      "keikka",
      "ajastus",
      "toiveikkuna",
      "tapahtumakohtaiset biisitoiveet",
      "biisitoiveraja",
      "aktiivinen tapahtuma",
      "näytä yleisölle",
      "piilota yleisöltä",
      "nopea ajastus",
      "plus",
    ],
    pages: ["events", "requests", "admin"],
    summary:
      "Tapahtumat kuuluvat Plus-pakettiin. Voit ajastaa keikan ja määrittää erikseen, milloin yleisö voi lähettää siihen biisitoiveita.",
    steps: [
      "Tapahtumat näkyvät hallinnassa Plus-käyttäjälle.",
      "Anna tapahtumalle nimi sekä tapahtuman alkamis- ja päättymispäivä ja kellonaika.",
      "Tapahtuman ajankohta kertoo, milloin itse keikka tai tapahtuma alkaa ja päättyy.",
      "Määritä erikseen biisitoiveiden toiveikkuna: milloin biisitoiveet avautuvat ja milloin ne sulkeutuvat.",
      "Biisitoiveet voivat avautua jo ennen varsinaisen tapahtuman alkua, mutta niiden pitää sulkeutua viimeistään tapahtuman päättyessä.",
      "Jos haluat ottaa biisitoiveita vastaan koko tapahtuman ajan, valitse ensin tapahtuman alku- ja loppuaika ja paina Käytä tapahtuman aikoja. Paranoidi kopioi silloin samat ajat biisitoiveiden avautumis- ja sulkeutumisajoiksi.",
      "Kaikki tapahtuman ja toiveikkunan päivämäärät sekä kellonajat ovat pakollisia.",
      "Voit asettaa tapahtumalle oman biisitoiveiden enimmäismäärän. Jätä kenttä tyhjäksi, jos tapahtumalla ei ole erillistä toiverajaa.",
      "Kun tapahtuman biisitoiveraja täyttyy, tapahtumaan ei voi lähettää lisää biisitoiveita.",
      "Näytä tapahtuma yleisölle -valinta määrittää, näkyykö tapahtuma julkisella Paranoidi-sivulla. Voit pitää tapahtuman tallessa mutta piilottaa sen yleisöltä poistamalla valinnan.",
      "Aktiivinen ja yleisölle näkyvä tapahtuma voidaan näyttää julkisen sivun tapahtumavalinnassa. Biisitoiveita voi kuitenkin lähettää siihen vain määritetyn toiveikkunan aikana.",
      "Yleisö voi valita tapahtuman biisitoiveen yhteydessä tai lähettää yleisen biisitoiveen ilman tapahtumaa.",
      "Tapahtumaan liitetty biisitoive näkyy Toivehallinnassa tapahtuma-merkinnällä.",
      "Tallennettua tapahtumaa voi myöhemmin muokata, piilottaa yleisöltä, näyttää uudelleen tai poistaa.",
      "Tapahtuman poistaminen poistaa tapahtuman pysyvästi. Siihen liitetyt biisitoiveet säilyvät yleisessä historiassa, mutta niiden tapahtumakytkentä poistuu.",
      "Sama selain/IP/toivoja voi jättää vain yhden aktiivisen biisitoiveen kerrallaan. Uuden voi lähettää, kun edellinen on käsitelty, poistettu tai merkitty soitetuksi.",
      "Tapahtumat eivät luo uusia yleisölinkkejä. Sama julkinen Paranoidi-linkki ja QR-koodi ovat käytössä kaikissa tapahtumissa.",
      "Kokeilussa ja Basic-paketissa tapahtumakohtaiset biisitoiveet eivät ole käytössä.",
    ],
  },
  {
    id: "requests",
    title: "Toivehallinta",
    tags: [
      "toiveet",
      "biisitoiveet",
      "toivehallinta",
      "soitettu",
      "nähty",
      "arvonta",
    ],
    pages: ["requests", "admin"],
    summary:
      "Toivehallinnassa näet yleisöltä tulleet biisitoiveet ja pidät keikan tilanteen järjestyksessä.",
    steps: [
      "Uudet biisitoiveet näkyvät Toivehallinnassa.",
      "Jos biisitoive on kohdistettu tapahtumaan, Toivehallinta näyttää tapahtuman nimen biisitoiveen yhteydessä.",
      "Sama selain/IP/toivoja voi jättää vain yhden aktiivisen biisitoiveen kerrallaan. Tämä pitää jonon selkeänä ja estää saman käyttäjän päällekkäiset toiveet.",
      "Jos samaa kappaletta toivotaan useita kertoja, Paranoidi voi näyttää kappaleen yhtenä ryhmänä. Ryhmän sisällä yksittäisten toiveiden nimet, viestit ja ajat säilyvät erillisinä.",
      "Jos yleisö toivoo biisiä, jota ei löydy ohjelmistosta, se näkyy Vapaissa biisitoiveissa.",
      "Merkitse toive nähdyksi, kun olet huomannut sen.",
      "Merkitse toive soitetuksi, kun se on toteutettu.",
      "Siivoa soitetut toiveet poistaa listalta vain soitetuksi merkityt toiveet. Uudet ja nähdyt toiveet jäävät jonoon.",
      "Jos maksulliset näkyvyysnostot ovat käytössä, nostetut aktiiviset toiveet näkyvät omassa Nostetut toiveet -osiossaan tavallisten toiveiden edellä.",
      "Jos nostettuja toiveita on useita, ne etenevät maksujärjestyksessä. Ensimmäisenä maksanut säilyttää paikkansa jonossa.",
      "Maksullinen näkyvyysnosto ei takaa kappaleen esittämistä.",
      "Mahdollinen toivearvonta otetaan käyttöön Asetuksista. Arvonta on käytettävissä vain, kun biisitoivekanava on auki yleisölle.",
      "Yleisö ei osallistu arvontaan automaattisesti. Osallistuminen vaatii, että toivoja valitsee biisitoiveen yhteydessä kohdan Haluan osallistua mahdolliseen arvontaan.",
      "Toivearvonta arpoo voittajan vain niiden biisitoiveiden joukosta, joissa osallistuja on valinnut olevansa mukana arvonnassa.",
      "Arvontaan osallistuminen ei vaikuta siihen, soitetaanko biisitoive.",
      "Aloita uusi keikka nollaa nykyisen keikkatilanteen, mutta tallennetut raportit säilyvät, jos pakettisi sisältää raportit.",
      "Biisitoiveet kuuluvat kaikkiin paketteihin, mutta laajemmat keikkaraportit ja tilastot kuuluvat Plus-pakettiin.",
    ],
  },
  {
    id: "setlists",
    title: "Settilistat ja lukutila",
    tags: [
      "settilista",
      "setit",
      "manuaalinen settilista",
      "aktiivinen setti",
      "aktiivinen settilista",
      "tallenna setti",
      "lataa setti",
      "sulje setti",
      "nykyinen keikka",
      "lukutila",
      "keikkanäkymä",
      "prompteri",
      "lavakäyttö",
      "soitettu",
      "ei soitettu",
    ],
    pages: ["setlists", "admin"],
    summary:
      "Settilistat ja lukutila kuuluvat Plus-pakettiin. Luo tai lataa settilista nykyiselle keikalle, muokkaa sitä ja käytä biisejä lavalla lukutilassa.",
    steps: [
      "Settilistat näkyvät hallinnassa vain, jos pakettisi sisältää tämän ominaisuuden.",
      "Voit tehdä settilistan käsin valitsemalla Luo tyhjä settilista ja lisäämällä biisit omasta Biisikirjastosta.",
      "Voit myös käyttää Luo uusi settilista -generaattoria. Valitse tilaisuus, kieli, settien määrä ja biisien määrä per setti. Tilaajan rajaukset ja toiveet -kohdasta voit käyttää tarkempia rajoituksia.",
      "Jos rajaat settilistan kielellä, generaattori käyttää vain niitä biisejä, joille kieli on merkitty Biisikirjastossa. Kieli puuttuu -biisit ovat mukana vain Kaikki kielet -valinnassa.",
      "Settilistaa voi muokata käsin: lisää ja poista biisejä, poista kokonaisia settejä sekä muuta biisien järjestystä.",
      "Lisäyshaku etsii biisejä omasta ohjelmistostasi. Valittuun tilaisuuteen sopivat biisit voidaan näyttää ensin, mutta voit lisätä myös muita kappaleita.",
      "Kun aloitat kokonaan uuden tai tyhjän settilistan, aiemmin aktiiviseksi ladattu tallennettu setti irrotetaan nykyisestä keikasta. Sen tallennettu versio säilyy edelleen Tallennetut setit -listassa.",
      "Kun tallennat uuden settilistan, tallennetusta setistä tulee samalla nykyisen keikan aktiivinen settilista.",
      "Tallennetun setin Lataa-painike tekee siitä nykyisen keikan aktiivisen settilistan. Aktiivinen tallennettu setti palautetaan myös sivun päivityksen jälkeen.",
      "Voit muokata aktiivista tallennettua settiä ja tallentaa muutokset Tallenna muutokset -painikkeella.",
      "Jos aktiiviseen settilistaan jää tallentamattomia muutoksia, Paranoidi näyttää niistä varoituksen ennen kuin unohdat tallentaa.",
      "Sulje setti poistaa settilistan nykyisen keikan aktiivisesta käytöstä. Tallennettu setti säilyy Tallennetut setit -listassa, mutta se ei palaudu aktiiviseksi sivun päivityksen jälkeen.",
      "Jos poistat aktiivisen tallennetun setin, se poistetaan samalla nykyisen keikan aktiivisesta käytöstä.",
      "Aloita uusi keikka sulkee edellisen keikan aktiivisen settilistan. Uusi keikka ei peri edellisen keikan settiä.",
      "Yhteenveto käyttää nykyisen keikan aktiivista settilistaa. Jos haluat settilistan mukaan keikkaraporttiin, pidä oikea setti aktiivisena raporttia tallentaessasi.",
      "Lukutilassa biisit avataan yksi kerrallaan keikan aikana.",
      "Lukutilassa näet sanat ja soinnut silloin, kun ne on tuotu biisille SongBook/ChordPro-tiedostosta tai lisätty käsin Muokkaa-toiminnolla. Lisäksi voit säätää tekstikokoa, vaihtaa väriteemaa, näyttää tai piilottaa soinnut ja käyttää prompteria.",
      "Keikan aikana voit merkitä settilistan biisin soitetuksi tai ei soitetuksi. Merkinnät tulevat mukaan keikkaraporttiin.",
      "Settilistan Lisätoiminnoista voit kopioida settilistan leikepöydälle, avata Tulosta / PDF -näkymän tai avata settilistan sähköpostiluonnokseen.",
      "Tulosta / PDF avaa selaimen tulostusikkunan. Valitse selaimesta Tallenna PDF:nä, jos haluat settilistan PDF-tiedostoksi.",
      "Kokeilussa ja Basic-paketissa settilistat, lukutila ja prompteri eivät ole käytössä.",
    ],
  },
 {
  id: "gig-notes",
  title: "Keikkamuisti",
  tags: [
    "keikkamuisti",
    "spiikki",
    "muistiinpano",
    "välispiikki",
    "muistutus",
    "linkitys",
    "keikkatyökalu",
  ],
  pages: ["notes", "setlists", "admin"],
  summary:
    "Keikkamuisti kuuluu Plus-pakettiin. Tallenna spiikit, muistutukset ja muut keikalla tarvittavat muistiinpanot ja liitä niitä tarvittaessa settilistan biiseihin.",
  steps: [
    "Keikkamuisti näkyy hallinnassa vain, jos pakettisi sisältää tämän ominaisuuden.",
    "Voit tallentaa Keikkamuistiin yleisiä muistiinpanoja, välispiikkejä ja muistutuksia.",
    "Tallennetun Keikkamuistin voi liittää yhteen tai useampaan settilistan biisiin.",
    "Biisiin liitetään Keikkamuistin linkki. Muistiinpanosta ei tehdä erillistä tekstikopiota biisiin.",
    "Jos sama Keikkamuisti on liitetty useaan biisiin, kaikki käyttävät samaa tallennettua muistiinpanoa.",
    "Kun muutat Keikkamuistia Keikkamuisti-näkymässä, uusi sisältö näkyy myös siihen linkitetyissä biiseissä.",
    "Voit muokata linkitettyä Keikkamuistia myös suoraan Keikkatyökalussa. Paina muutoksen jälkeen Tallenna Keikkamuisti.",
    "Keikkatyökalussa tallennettu muutos päivittää saman alkuperäisen Keikkamuistin ja näkyy myös muissa siihen linkitetyissä biiseissä.",
    "Irrota biisistä poistaa vain Keikkamuistin linkin kyseisestä biisistä. Itse Keikkamuisti säilyy tallennettuna.",
    "Biisin oma käsin kirjoitettu muistiinpano on erillinen eikä muuta Keikkamuistia.",
    "Kiinnitetyt muistiinpanot pysyvät helpommin löydettävissä.",
    "Keikkamuistin merkinnät voivat näkyä keikkaraportissa, jos ne liittyvät käytettyyn settilistaan.",
    "Kokeilussa ja Basic-paketissa Keikkamuisti ei ole käytössä.",
  ],
},
  {
    id: "summary",
    title: "Yhteenveto ja keikkaraportit",
    tags: [
      "yhteenveto",
      "raportti",
      "tilastot",
      "keikka",
      "nykyinen keikka",
      "aloitusaika",
      "keikan kesto",
      "toivetilastot",
      "näkyvyysnostot",
      "nostot",
      "soitettu",
      "ei soitettu",
      "skipped",
      "settilista",
      "aktiivinen settilista",
    ],
    pages: ["summary", "reports", "admin"],
    summary:
      "Yhteenveto näyttää nykyisen keikan tilanteen. Keikkaraportilla voit tallentaa biisitoiveet, aktiivisen settilistan, keikkamerkinnät, Keikkamuistin ja keikan ajalliset tiedot myöhempää tarkastelua varten.",
    steps: [
      "Nykyinen keikka -kohdassa näet, mistä ajankohdasta keikan tilastoja lasketaan sekä mikä settilista on tällä hetkellä aktiivinen.",
      "Keikan aloitusaika tallennetaan, kun painat Aloita uusi keikka. Jos vanhalle keikkatilanteelle ei ole tallennettua aloitusaikaa, Paranoidi ei yritä arvata sitä jälkikäteen.",
      "Yhteenveto näyttää muun muassa biisitoiveiden määrän, eri biisien määrän, soitetut ja käsittelemättömät toiveet sekä vapaat biisitoiveet.",
      "Jos maksullisia näkyvyysnostoja on käytetty, Yhteenveto näyttää nostettujen toiveiden määrän ja nostoista maksetun yhteissumman.",
      "Jos Keikkatyökalussa on aktiivinen settilista, Yhteenveto näyttää sen nimen, tilaisuuden ja settilistan biisit.",
      "Settilistan biisikohtaiset merkinnät, kuten soitettu ja ei soitettu, tulevat mukaan keikkaraporttiin.",
      "Jos settilistan biiseihin tai keikkaan on liitetty Keikkamuistin muistiinpanoja, ne voidaan tallentaa raportin mukana.",
      "Tallenna keikkaraportti tekee pysyvän snapshotin senhetkisestä keikkatilanteesta.",
      "Raporttiin tallennetaan raportin tallennushetki. Jos keikalle on tallennettu aloitusaika, Paranoidi laskee myös keikan keston aloituksesta raportin tallennushetkeen.",
      "Aloita uusi keikka aloittaa uuden keikkasession, poistaa nykyiset biisitoiveet, sulkee aktiivisen settilistan ja nollaa arvonnan. Tallennetut keikkaraportit, Biisikirjasto ja Keikkamuisti säilyvät.",
      "Keikkaraportit ja laajemmat keikkatilastot kuuluvat Plus-pakettiin.",
      "Kokeilussa ja Basic-paketissa keikkaraportit eivät ole käytössä.",
    ],
  },
  {
    id: "sponsors",
    title: "Sponsorit",
    tags: ["sponsorit", "logo", "mainos", "yhteistyökumppani"],
    pages: ["settings", "sponsors"],
    summary:
      "Sponsorit kuuluvat Plus-pakettiin. Niillä voi näyttää yhteistyökumppanin biisitoiveen yhteydessä.",
    steps: [
      "Sponsorit näkyvät hallinnassa vain, jos pakettisi sisältää tämän ominaisuuden.",
      "Voit lisätä enintään 5 sponsoria.",
      "Sponsorille voi lisätä nimen, mainostekstin, linkin ja logon.",
      "Logon sallittu muoto on PNG, JPG tai WebP.",
      "Suurin sallittu logokoko on 1 Mt.",
      "Sponsorikortti voidaan näyttää yleisölle biisitoiveen lähetyksen yhteydessä sekä ohjelmiston Satunnainen kappale -toiminnon yhteydessä.",
      "Jos sponsoreita on useampi, näytettävä sponsori valitaan satunnaisesti.",
      "Kokeilussa ja Basic-paketissa sponsorit eivät ole käytössä.",
    ],
  },
  
  {
    id: "paid-request-boosts",
    title: "Maksulliset biisitoiveiden näkyvyysnostot",
    tags: [
      "stripe",
      "maksut",
      "3 €",
      "3e",
      "näkyvyysnosto",
      "biisitoiveen nosto",
      "maksullinen biisitoive",
      "maksutili",
      "tilitys",
    ],
    pages: ["settings", "requests", "admin"],
    summary:
      "Voit antaa yleisölle mahdollisuuden nostaa oman biisitoiveensa 3 € maksulla tavallisten toiveiden edelle. Jos nostettuja toiveita on useita, ne etenevät maksujärjestyksessä. Maksu ei takaa kappaleen esittämistä.",
    steps: [
      "Avaa Hallinta → Asetukset → Maksut. Paina Yhdistä Stripe. Sinut siirretään Stripen omalle turvalliselle käyttöönotto- ja tunnistautumissivulle.",

      "Aloita Stripen käyttöönotto. Stripe voi kysyä aluksi, millaisena henkilönä tai yrityksenä vastaanotat maksuja. Valitse omaa todellista toimintaasi vastaava vaihtoehto. Näytettävät vaihtoehdot voivat vaihdella käyttäjästä riippuen.",

      "Täytä Stripen pyytämät henkilö- tai yritystiedot. Stripe voi kysyä esimerkiksi virallista nimeä, yrityksen nimeä, yritysmuotoa, Y-tunnusta tai muita toimintaan liittyviä tietoja sen mukaan, millaisena maksunsaajana rekisteröidyt.",

      "Täytä omat henkilötietosi täsmälleen oikein. Stripe voi pyytää esimerkiksi etunimen, sukunimen, syntymätietoja, puhelinnumeron ja sähköpostiosoitteen. Käytä samoja virallisia tietoja, joilla henkilöllisyytesi voidaan vahvistaa.",

      "Täytä osoitetiedot huolellisesti. Stripe voi pyytää katuosoitteen, postinumeron ja kaupungin. Virheelliset tai puutteelliset tiedot voivat estää henkilöllisyyden vahvistamisen.",

      "Stripe voi kysyä myös toimintaasi liittyviä tietoja, kuten mitä palvelua tarjoat tai millaista toimintaa maksut koskevat. Vastaa oman esiintyjä- tai yritystoimintasi mukaisesti.",

      "Lisää Stripen pyytämä tilitystili. Anna pankkitilin tiedot sille tilille, jolle haluat näkyvyysnostojen maksujen tilitettävän. Tarkista tilinumero ennen jatkamista.",

      "Tee henkilöllisyyden vahvistus, jos Stripe sitä pyytää. Stripe voi pyytää vahvistamaan henkilöllisyytesi tai toimittamaan henkilöllisyysasiakirjan. Seuraa Stripen näytöllä antamia ohjeita. Paranoidi ei käsittele henkilöllisyysasiakirjaasi.",

      "Tarkista Stripen näyttämä yhteenveto. Jos jonkin kohdan vieressä näkyy virhe, puuttuva tieto tai vahvistuspyyntö, avaa kyseinen kohta ja korjaa tiedot ennen lähettämistä.",

      "Hyväksy Stripen ehdot ja paina lopuksi Hyväksy ja lähetä tai muuta Stripen näyttämää vastaavaa vahvistuspainiketta. Odota, että käsittely valmistuu äläkä sulje tai päivitä sivua kesken lähetyksen.",

      "Kun Stripe palauttaa sinut Paranoidiin, Asetukset tarkistaa maksutilin tilanteen. Pelkkä paluu Paranoidiin ei vielä tarkoita, että Stripe olisi hyväksynyt kaikki tiedot.",

      "Jos Paranoidissa näkyy Stripe-yhteys on kesken, Stripe tarvitsee vielä tietoja tai vahvistuksen. Paina Jatka Stripe-käyttöönottoa ja täytä Stripen pyytämät puuttuvat kohdat.",

      "Kun Paranoidissa näkyy Stripe yhdistetty ✓, sekä maksujen vastaanotto että tilitykset ovat valmiina.",

      "Ota tämän jälkeen käyttöön Salli maksullinen 3 € näkyvyysnosto ja paina mukana kulkevasta tallennuspalkista Tallenna asetukset. Stripe-yhteyden tekeminen ei yksinään avaa maksullisia näkyvyysnostoja.",

      "Kun biisitoivekanava on avoinna ja näkyvyysnostot ovat käytössä, yleisö voi maksaa 3 € ja nostaa oman biisitoiveensa tavallisten toiveiden edelle. Jos nostettuja toiveita on useita, ne etenevät maksujärjestyksessä: ensimmäisenä maksanut säilyttää paikkansa. Maksu ei takaa kappaleen esittämistä.",

      "Paranoidi ei tällä hetkellä peri näkyvyysnostosta provisiota. Stripe vähentää maksusta omat maksunkäsittelykulunsa ja tilittää jäljelle jäävän summan yhdistetylle maksutilillesi.",

      "Stripe voi myöhemmin pyytää uusia tai päivitettyjä tietoja. Jos maksujen vastaanotto tai tilitykset keskeytyvät tämän vuoksi, avaa Asetukset ja jatka Stripe-käyttöönottoa.",
    ],
  },

  {
    id: "subscription",
    title: "Paketit ja tilaus",
    tags: ["tilaus", "paketit", "kokeilu", "trial", "basic", "plus"],
    pages: ["subscription", "settings"],
    summary:
      "Paranoidissa on 14 päivän kokeilu, Basic ja Plus. Käytössä näkyvät ominaisuudet määräytyvät tilausmuodon mukaan.",
    steps: [
      "14 päivän kokeilu sopii oman Paranoidi-verkkosivun ja ensimmäisten biisitoiveiden testaamiseen.",
      "Kokeilussa Biisikirjaston raja on 20 biisiä. Saat käyttöösi oman julkisen sivun, QR-koodin, jaettavan linkin, perusbiisikirjaston, tavalliset ja vapaat biisitoiveet sekä toivearvonnan opt-in-toiminnon.",
      "Basicissa Biisikirjaston raja on 100 biisiä. Basic lisää julkisen sivun laajemmat asetukset, hero-kuvan, linkit, WhatsApp-yhteyden, Google-otsikon ja -kuvauksen, UKK:n, kielisuodatuksen sekä biisien näkyvyyden hallinnan.",
      "Plus-paketissa Biisikirjaston raja on 500 biisiä. Plus sisältää Basicin lisäksi tapahtumat, tapahtumakohtaiset biisitoiveet, tiedostotuonnit ja Google Drive -tuonnin, settilistat, tallennetut setit, lukutilan, prompterin, keikkamuistin, live-yhteenvedon, keikkaraportit ja sponsorit.",
      "Jos jokin ominaisuus ei näy hallinnassa, se ei välttämättä kuulu nykyiseen pakettiisi.",
      "Pakettia voi vaihtaa Tilaus-sivulta. Tilauksen hallinta, paketin vaihto ja peruutukset avautuvat Stripe-asiakasportaalissa.",
      "Jos peruutat tilauksen, Stripe näyttää päättymispäivän. Peruutuksen voi myös poistaa portaalista, jos haluat jatkaa tilausta.",
    ],
  },
  {
    id: "troubleshooting",
    title: "Vikatilanteet",
    tags: ["vika", "ongelma", "ei näy", "tallennus", "päivitys", "paketti"],
    pages: ["admin", "settings", "songs", "requests"],
    summary:
      "Yleisimmät korjauskeinot, jos jokin ei näy tai tallennu.",
    steps: [
      "Jos jokin ominaisuus ei näy hallinnassa, tarkista ensin, kuuluuko se nykyiseen pakettiisi.",
      "Jos olet muuttanut Asetuksia, paina mukana kulkevasta tallennuspalkista Tallenna asetukset.",
      "Jos julkinen Paranoidi-sivu näyttää vanhaa tietoa, päivitä sivu ensin normaalisti ja tarvittaessa kovalla päivityksellä: Ctrl + F5.",
      "Jos muutokset eivät tämän jälkeen näy, kirjaudu Paranoidista ulos ja takaisin sisään.",
      "Jos Stripe-yhteys näkyy keskeneräisenä, avaa Asetukset → Maksut ja jatka Stripe-käyttöönottoa.",
      "Jos ongelma jatkuu, ota yhteyttä Paranoidin tukeen ja kerro, mitä olit tekemässä ja mitä sivulla näkyi.",
    ],
  },
];

export function getLocalizedHelpSections(t) {
  if (typeof t !== "function") {
    return helpSections;
  }

  return helpSections.map((section) => {
    const baseKey = `helpSections.${section.id}`;

    const translatedTags = t(`${baseKey}.tags`, {
      returnObjects: true,
    });

    const translatedSteps = t(`${baseKey}.steps`, {
      returnObjects: true,
    });

    return {
      ...section,
      title: t(`${baseKey}.title`, {
        defaultValue: section.title,
      }),
      tags: Array.isArray(translatedTags)
        ? translatedTags
        : section.tags,
      summary: t(`${baseKey}.summary`, {
        defaultValue: section.summary,
      }),
      steps: Array.isArray(translatedSteps)
        ? translatedSteps
        : section.steps,
    };
  });
}

export function getHelpSectionForPath(pathname = "", hash = "") {
  const path = `${pathname || ""} ${hash || ""}`.toLowerCase();

  if (path.includes("subscription")) return "subscription";

  if (path.includes("settings-payments")) return "paid-request-boosts";
  if (path.includes("settings-google")) return "seo-faq";
  if (path.includes("settings-general")) return "public-channel";
  if (path.includes("settings")) return "settings";

  if (path.includes("imports")) return "imports";
  if (path.includes("events")) return "events";
  if (path.includes("requests")) return "requests";
  if (path.includes("sponsors")) return "sponsors";
  if (path.includes("summary")) return "summary";
  if (path.includes("songs")) return "song-library";
  if (path.includes("setlists")) return "setlists";
  if (path.includes("notes")) return "gig-notes";

  return "quickstart";
}
